// extracted by mini-css-extract-plugin
module.exports = {"root":"SetPasswdForm_root__IEKvp","label":"SetPasswdForm_label__27jYw"};